var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpFromBracketSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0594 0.402852C11.4734 -0.134284 10.5219 -0.134284 9.93594 0.402852L3.93594 5.90312C3.35 6.44026 3.35 7.31256 3.93594 7.8497C4.52188 8.38684 5.47344 8.38684 6.05937 7.8497L9.5 4.69564V13.7496C9.5 14.5102 10.1703 15.1247 11 15.1247C11.8297 15.1247 12.5 14.5102 12.5 13.7496V4.69564L15.9406 7.8497C16.5266 8.38684 17.4781 8.38684 18.0641 7.8497C18.65 7.31256 18.65 6.44026 18.0641 5.90312L12.0641 0.402852H12.0594ZM3.5 15.1247C3.5 14.3641 2.82969 13.7496 2 13.7496C1.17031 13.7496 0.5 14.3641 0.5 15.1247V17.8748C0.5 20.1523 2.51562 22 5 22H17C19.4844 22 21.5 20.1523 21.5 17.8748V15.1247C21.5 14.3641 20.8297 13.7496 20 13.7496C19.1703 13.7496 18.5 14.3641 18.5 15.1247V17.8748C18.5 18.6354 17.8297 19.2499 17 19.2499H5C4.17031 19.2499 3.5 18.6354 3.5 17.8748V15.1247Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpFromBracketSolid);
export default __webpack_public_path__ + "static/media/arrow-up-from-bracket-solid.d41d9c8b5752da3c9298d6bd9dcbd559.svg";
export { ForwardRef as ReactComponent };